<template>
    <div>
        <div class="modal fade" id="changePasswordJm" tabindex="-1" aria-labelledby="loginLabel" aria-hidden="true"
            data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content" :style="skin.header_desktop.nav_bar">
                    <div class="modal-body p-4" style="font-family: 'Exo 2', sans-serif !important;">
                        <div class="container form-large">
                            <span v-if="showChangePassword">{{ translate('sugerencia') }}</span>
                            <form @submit.prevent="changePassword()" class="">
                                <h1 :style="{ 'color': skin.main_modal_background }">{{ translate('change_password') }}
                                </h1>
                                <label style="color:white" for="">{{ translate('user') }}</label><br><br>
                                <label style="color:white" for="">{{ user.user_data?.data?.user_name }}</label><br><br>
                                <div class="pb-2 font-size-custom mb-3 my-3">
                                    <label style="color:white" for="passwordJm">{{ translate('current') }}</label><br>
                                    <i class="fas fa-eye prefix change-password-reveal lightgrey-text mx-2"
                                        @click="show_hide_Password('passwordJm')"></i>
                                    <input type="password" :placeholder="translate('key1')" class="login-user-control"
                                        autocomplete="off" required>
                                </div>
                                <div class="pb-2 font-size-custom mb-3 my-3">
                                    <label style="color:white" for="passwordJm">{{ translate('new_password')
                                        }}</label><br>
                                    <i class="fas fa-eye prefix change-password-reveal lightgrey-text mx-2"
                                        @click="show_hide_Password('passwordJm')"></i>
                                    <input v-model="password" id="passwordJm" type="password"
                                        :placeholder="translate('new_password')" class="login-user-control"
                                        autocomplete="off" required>
                                </div>
                                <div class="pb-2 font-size-custom mb-3 my-3">
                                    <label style="color:white" for="passwordJm2">{{ translate('repeat_password')
                                        }}</label><br>
                                    <i class="fas fa-eye prefix change-password-reveal lightgrey-text mx-2"
                                        @click="show_hide_Password('passwordJm2')"></i>
                                    <input v-model="password2" id="passwordJm2" type="password"
                                        :placeholder="translate('repeat_password')" class="login-user-control"
                                        maxlength="16" autocomplete="off" required>
                                </div>
                                <br>
                                <div class="d-grid gap-2">
                                    <button id="submit_btn2" type="submit" class="btn p-2 mx-2"
                                        :style="{ 'background-color': skin.main_modal_background, 'color': skin.main_modal_text }"
                                        style="font-size: small;font-weight: bold;" :disabled="login_inProcess">{{
                                        translate('actual') }}</button>
                                    <button class="btn p-2 mx-2" type="button"
                                        :style="{ 'background-color': skin.main_modal_background, 'color': skin.main_modal_text }"
                                        style="font-size: small;text-transform: uppercase; font-weight: bold;"
                                        data-bs-dismiss="modal" aria-label="Close">{{ translate('close') }}</button>
                                </div>
                            </form>
                            <div v-if="status.message != ''" :class="'alert alert-' + status.type" role="alert">{{
                                status.message }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: "changePassword",
    props: ['skin', 'translation', 'language'],
    data() {
        return {
            password: "",
            password2: "",
            show1: true,
            show2: true,
            status: {
                message: "",
                type: ""
            },
            login_inProcess: false
        }
    },
    computed: {
        user() {
            let data = this.$store.getters['getUserData'];
            return data;
        },
        showChangePassword() {
            return this.$store.getters['getShowChangePassword'];
        },
        apiUrlnew() {
            return this.$store.getters['getApiUrlnew'];
        },
        site() {
            return this.$store.getters['getSite'];
        },
    },
    methods: {
        async changePassword() {
            try {
                this.login_inProcess = true;
                console.log("David2", this.apiUrlnew, this.user)
                let data = await axios.post(this.apiUrlnew + "user/cambiar_password",
                    {
                        "users": [this.user.user_data.data.user_id ?? this.user.user_data.data.id],
                        "password": this.password,
                        "password1": this.password2,
                        //"token":this.user.token,
                        "login_id": this.user.user_data.data.user_id ?? this.user.user_data.data.id,
                        //"site": this.site
                    },
                    {
                        headers: {
                            "x-player-token": this.user.token,
                            "x-api-key": "FTBBW4bR1pKTUFsURbFD8RpcPygh8wN6"
                        }
                    }
                );
                if (data.data.error) {
                    this.status.message = data.data.error;
                    this.status.type = "danger";
                }
                else {
                    this.status.message = data.data.message;
                    this.status.type = "success";
                    this.logout();
                    setTimeout(() => {
                        document.getElementById("closeChangePassword").click();
                    }, 2000)
                }
                this.login_inProcess = false;
            } catch (error) {
                this.status.message = error.response.data.error;
                this.status.type = "danger";
                this.login_inProcess = false;
            }

        },
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        show_hide_Password(target) {
            if (target == "password") {
                document.getElementById(target).type = this.show1 ? "text" : "password";
                this.show1 = !this.show1;
            }
            else {
                document.getElementById(target).type = this.show2 ? "text" : "password";
                this.show2 = !this.show2;
            }
        },
    }
}
</script>

<style scoped>
.modal-header2 {
    margin-left: 5% !important;
    margin-right: 5% !important;
    margin-top: -1.25rem !important;
    margin-bottom: 0 !important;
    height: 60px;
    padding: 1rem !important;
    color: #fff;
    border-bottom: none;
    background: linear-gradient(40deg, #292d3d, #03040d) !important
}

.close2 {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}

.login-user-control {
    color: #fff;
    margin-left: 2.5rem;
    width: calc(100% - 2.5rem);
    -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    -o-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #ced4da;
    -webkit-border-radius: 0;
    border-radius: 0;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    background-color: transparent;
    margin: 0 0 0.5rem;
    -webkit-border-radius: 0;
    border-radius: 0;
    padding: 0.3rem 0 0.55rem;
    background-image: none;
    background-color: transparent;
    height: auto;
}

h1 {
    margin-top: 0;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 18px;
}

.form-large {
    padding: 50px;
    border-radius: 20px;
    margin-top: 35px;
    background-color: black;
    padding: 30px;
    border-radius: 20px;
    max-width: 480px;
}
</style>